"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCompleteLocationAddress = exports.locationAddressText = void 0;
const locationAddressText = (locationAddress) => {
    if (!locationAddress) {
        return "unavailable";
    }
    const { streetAddress, suburb, state } = locationAddress;
    return streetAddress || `${suburb}, ${state}`;
};
exports.locationAddressText = locationAddressText;
const isCompleteLocationAddress = (locationAddress) => {
    if (!locationAddress) {
        return false;
    }
    for (const addressProperty in locationAddress) {
        if (!locationAddress[addressProperty]) {
            return false;
        }
    }
    return true;
};
exports.isCompleteLocationAddress = isCompleteLocationAddress;
//# sourceMappingURL=location.js.map